export const DEFAULT_CONTENT_WIDTH = 500;

export const DEFAULT_IMAGE_WIDTH_OLD = 221;
export const DEFAULT_IMAGE_WIDTH = 235;
export const DEFAULT_IMAGE_HEIGHT = 138;

export const CROSS_PROJECT_CONTENT_WIDTH = 600;
export const CROSS_PROJECT_IMAGE_WIDTH = 380;
export const CROSS_PROJECT_IMAGE_HEIGHT = 199;

export const LARGE_IMAGE_WIDTH = 344;
export const LARGE_IMAGE_HEIGHT = 167;
